import { Component } from "@angular/core";

@Component({
  selector: "app-artform",
  standalone: true,
  imports: [],
  templateUrl: "./artform.html",
  styleUrl: "./artform.css",
})
export class Artform {}
